import * as React from "react";
const SvgHelp20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "black",
        viewBox: "0 0 18 18"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M9 2a7 7 0 1 0 0 14A7 7 0 0 0 9 2ZM0 9a9 9 0 1 1 18 0A9 9 0 0 1 0 9Zm10.2 4a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0Zm-.955-9.5a4.006 4.006 0 0 0-2.833 1.173l-.619.62 1.414 1.414.62-.62A2.006 2.006 0 0 1 9.245 5.5h.427c.457 0 .828.37.828.828 0 .437-.198.85-.54 1.123l-.834.668A3 3 0 0 0 8 10.46v.339h2v-.339a1 1 0 0 1 .375-.78l.835-.668a3.438 3.438 0 0 0 1.29-2.685A2.828 2.828 0 0 0 9.672 3.5h-.427Z",
      clipRule: "evenodd"
    })
  );
export default SvgHelp20Px;
